"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.environmentContext = void 0;
var _react = require("react");
var _constants = require("../../constants");
const defaultValues = {
  environment: _constants.ENVIRONMENT_CODES.LIVE,
  tenant: _constants.DEFAULT_TENANT
};
const environmentContext = exports.environmentContext = /*#__PURE__*/(0, _react.createContext)(defaultValues);
